<template>
  <div class="companyIntroComponent">
    <div class="aside_left">
      <div class="left_top">
        <div class="portrait">
          <div class="porate_quert">
            <img :src="userInfo.headUrl" alt="" />
          </div>
        </div>
        <div class="wire">
          <p>{{ userInfo.name }}</p>
        </div>
      </div>
      <div class="left_bat">
        <p class="fdc">
          <span>企业类型 :</span><span>{{ userInfo.companytypestr }}</span>
        </p>
        <p class="fdc">
          <span>企业地址 :</span>
          <span v-if="userInfo.location">{{ userInfo.location.replace(/,/g,'/') }}</span>
          <span v-else></span>
        </p>
        <p class="fdc">
          <span>企业认证 :</span
          ><span>{{ caculateCompanyStatus(userInfo.status) }}</span>
        </p>
        <p class="fdc">
          <span>所属行业 :</span><span>{{cate}}</span>
        </p>
        <p class="fdc">
          <span>经营范围 :</span
          ><span class="mt-10">{{ userInfo.businessScope }}</span>
        </p>
        <!-- <p class="fdc">
          <span>联系方式 :</span><span>{{ userInfo.telphone }}</span>
        </p> -->
        <p class="fdc">
          <span> 地 &nbsp;&nbsp;&nbsp;&nbsp; 址 :</span
          ><span>{{ userInfo.address }}</span>
        </p>
      </div>
      <div v-if="index == true"  class="left_far" @click.prevent="onClick()">
        <img src="@/assets/images/nostars.png" alt="">
        <span class="left_bartext">收藏</span>
      </div>
      <div v-else class="left_far" @click.prevent="onCall()">
         <img src="@/assets/images/stars.png" alt="">
        <span class="left_bartext">收藏</span>
      </div>
    </div>
  </div>
</template>
<script>
import { iscollection,addCollection ,cancelcollection} from "@/api/coment";
import { getToken } from "@/utils/auth";
export default {
  name: "companyIntroComponent",
  props:{
	notStatus:{
	  type:Boolean
	}
  },
  data() {
    return {
      id:'',
      statusList: ["待认证", "认证通过", "认证拒绝"],
      index:true,
      cate:''
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.companyInfo;
    },
    industryName() {
      if (!this.userInfo.industry) return;
      return this.$store.getters.itemIndutry(this.userInfo.industry);
    },
  },
  created(){
    let id  = sessionStorage.getItem('corporateId')
      // if(this.notStatus == true){
      //     this.index = 1
      // }else{
      //     this.index = 0;
      // }
      // if(getToken() !=undefined){
      //    this.getiscollection();
      // }

  },
  methods: {
    //企业认证状态
    caculateCompanyStatus(status) {
      if(status == '-1'){
        status = 0
      }
      return this.statusList[status];
    },
    //查询收藏状态
    getiscollection(){
        let params ={
          goodsid:this.userInfo.userId,
          goodstype:7
        }
        iscollection(params).then((res)=>{
        if(res.data == 0){
          this.$message({
            message:'收藏成功',
            type:'success',
            duration:1000
          })
          this.index=res.data?1:0;
        }
        }).catch((err)=>{})
    },
    //点击收藏
    onClick(){
      this.index = !this.index;
      this.goCollection();
    },
    //取消
    onCall(){
      this.index = !this.index;
      this.callCancelcollection();
    },
    //添加收藏
     goCollection(){
      addCollection({
        goodsId:this.userInfo.userId,
        goodsType:7
      }).then((res)=>{
        if(res.code ==0){
            this.$message({
              type:"success",
              message:"收藏成功"
            })
        }
      }).catch((err)=>{})
     },
     //取消收藏
     callCancelcollection(){
       let params = {
          goodsid:this.userInfo.userId.toString(),
          goodstype:"7"
       }
       cancelcollection(params).then((res)=>{
         if(res.code == 0){
            this.$message({
              type:"success",
              message:"取消收藏"
            })
         }
       }).catch((err)=>{})
     },
     getCate(id) {
        return this.$store.getters.comyIndustry(id);
     },
  },
  watch:{
    userInfo(val){
      this.cate = this.getCate(Number(val.industry));
    },
    notStatus:{
      immediate:true,
      handler(val){
        val==true?this.index=false:this.index=true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.aside_left {
  // height: 532px;
  background: #ffffff;
  border: 1px solid #ededed;
  padding: 20px 20px;
}
.left_top {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.portrait {
  width: 107px;
  height: 107px;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.porate_quert{
  width: 70px;
  height: 70px;
  overflow: hidden;
}
.porate_quert img{
  width: 100%;
  height:100%;
  // border-radius: 100%;
  object-fit: cover;
}
.wire {
  margin-top: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #999999;
}
.wire p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.left_bat {
  text-align: left;
  margin-top: 20px;
  margin-left: 30px;
}
.left_bat p {
  align-items: baseline;
}
.left_bat p span:first-child {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.left_bat p span:last-child {
  flex: 1;
  margin-left: 10px;
  margin-right: 20px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.left_far {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 15px;
}
.left_far img {
  width: 17px;
  height: 16px;
  margin-right: 10px;
}
.left_bartext {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/companyintroCard.vue